<template>
  <div v-if="show" class="account-dialog-overlay">
    <div class="account-dialog">
      <h2 class="dialog-title">Enter Code</h2>
      <h4 class="dialog-info-instructions">Please enter the verification code that was sent to you via email. If you don't see it, check your spam folder.</h4>
      <div v-if="validationError" class="dialog-error-message">
        {{ validationError }}
      </div>
      <form @submit.prevent="onSubmit">
        <div class="dialog-form-group">
          <input id="validation-code" v-model="localValidationCode" type="text" maxlength="6" required 
                 autocomplete="one-time-code" class="dialog-input"
                 @input="onInput"
                 pattern="[0-9]{6}"
                 title="Invalid verification code" />
        </div>
        <div class="dialog-actions">
          <button class="dialog-cancel-btn" type="button" @click="$emit('close')" :disabled="isLoading">Cancel</button>
          <button class="dialog-save-btn" type="submit" :disabled="isLoading">
            <span v-if="!isLoading">Submit</span>
            <span v-else class="spinner"></span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignupValidationDialog',
  props: {
    show: Boolean,
    validationError: String,
    validationCode: String,
    isLoading: Boolean
  },
  emits: ['close', 'submit', 'update:validationCode'],
  data() {
    return {
      localValidationCode: this.validationCode || ''
    };
  },
  watch: {
    validationCode(newVal) {
      this.localValidationCode = newVal;
    }
  },
  methods: {
    onInput(e) {
      this.$emit('update:validationCode', e.target.value);
    },
    onSubmit() {
      this.$emit('submit');
    }
  }
};
</script>

<style scoped>

</style>
